import React from "react";
import i18n from "i18next";
import { LuUpload } from "react-icons/lu";

const VideoUploadSection = ({
  fileInputRef,
  uploadFile,
  uploadPreview,
  uploadUploading,
  uploadUploaded,
  uploadError,
  uploadPercentage,
  uploadStatusMessage,
  uploadErrorMessage,
  onSelect,
  onDrop,
  onDragOver,
  onDragLeave,
  onSubmit,
  onClear,
}) => (
  <div className="add-video-modal__upload">
    <input
      ref={fileInputRef}
      type="file"
      className="add-video-modal__upload-input"
      style={{ display: "none" }}
      accept="video/*,.mp4,.webm,.mov,.avi,.mkv,.m4v,.flv,.wmv,.mpg,.mpeg,.3gp,.ogv,.ts,.mts"
      onChange={onSelect}
    />

    {!uploadFile && !uploadUploading && !uploadUploaded && (
      <div
        data-local-dropzone="video-upload"
        className={`add-video-modal__upload-dropzone${
          uploadError ? " add-video-modal__upload-dropzone--error" : ""
        }`}
        onClick={() => fileInputRef.current?.click()}
        onDrop={onDrop}
        onDragOver={onDragOver}
        onDragLeave={onDragLeave}
      >
        <div className="add-video-modal__upload-icon">
          <LuUpload />
        </div>
        <div className="add-video-modal__upload-title">
          {i18n.t("FileModal.APIProviders.VideoGeneration.UploadDropTitle") ||
            "Click to upload or drag and drop"}
        </div>
        <div className="add-video-modal__upload-subtitle">
          {i18n.t("FileModal.APIProviders.VideoGeneration.UploadDropSubtitle") ||
            "MP4, MOV, or WEBM (max 500MB)"}
        </div>
        {uploadError && uploadErrorMessage && (
          <div className="add-video-modal__upload-status add-video-modal__upload-status--error">
            <span>{uploadErrorMessage}</span>
          </div>
        )}
      </div>
    )}

    {(uploadFile || uploadUploading || uploadUploaded) && (
      <div className="add-video-modal__upload-preview">
        <div className="add-video-modal__upload-preview-video">
          {uploadPreview && <video src={uploadPreview} controls muted preload="metadata" />}
        </div>

        <div className="add-video-modal__upload-preview-info">
          <div className="add-video-modal__upload-filename">{uploadFile?.name}</div>

          {!uploadUploaded && !uploadUploading && (
            <div className="add-video-modal__upload-actions">
              <button
                type="button"
                className="add-video-modal__btn add-video-modal__btn--primary"
                onClick={onSubmit}
              >
                <LuUpload style={{ marginRight: 6 }} />
                {i18n.t("FileModal.APIProviders.upload")}
              </button>
              <button
                type="button"
                className="add-video-modal__btn add-video-modal__btn--ghost"
                onClick={onClear}
              >
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  fill="none"
                  style={{ marginRight: 6 }}
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
                {i18n.t("FileModal.APIProviders.clear")}
              </button>
            </div>
          )}

          {uploadUploading && (
            <div className="add-video-modal__upload-progress">
              {uploadStatusMessage ? (
                <div className="add-video-modal__upload-progress-text">{uploadStatusMessage}</div>
              ) : (
                <>
                  <div className="add-video-modal__upload-progress-bar">
                    <div
                      className="add-video-modal__upload-progress-fill"
                      style={{ width: `${uploadPercentage}%` }}
                    />
                  </div>
                  <div className="add-video-modal__upload-progress-text">{uploadPercentage}%</div>
                </>
              )}
            </div>
          )}

          {uploadUploaded && (
            <div className="add-video-modal__upload-status add-video-modal__upload-status--success">
              <svg
                viewBox="0 0 24 24"
                width="18"
                height="18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
              <span>{i18n.t("FileModal.APIProviders.uploaded")}</span>
            </div>
          )}

          {uploadError && (
            <div className="add-video-modal__upload-status add-video-modal__upload-status--error">
              <svg
                viewBox="0 0 24 24"
                width="18"
                height="18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
              >
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
              <span>{uploadErrorMessage || i18n.t("FileModal.APIProviders.error")}</span>
            </div>
          )}

          {uploadUploaded && (
            <button
              type="button"
              className="add-video-modal__btn add-video-modal__btn--primary"
              onClick={onClear}
            >
              {i18n.t("FileModal.APIProviders.UploadNewFile")}
            </button>
          )}
        </div>
      </div>
    )}
  </div>
);

export default VideoUploadSection;
